//@flow
import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import {
  Chip,
  Grid,
  Card,
  CardContent,
  Hidden,
  Typography,
} from '@material-ui/core';
import CustomButton from '../../../../elements/CustomButton/CustomButton';
import {ArrowBack} from '@material-ui/icons';
import {colors} from '../../../../assets/styles/colors';
import maskImage from '../../../../assets/img/maskImage.png';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import CardReceipt from '../CardReceipt/CardReceipt';

type Props = {||};

const useStyles = makeStyles(theme => ({
  headerWrap: {
    height: 56,
    position: 'sticky',
    top: 72,
    zIndex: 2,
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(2, 0),
  },
  headerText: {
    color: colors.grey900,
    fontSize: '24px',
    fontWeight: 600,
    margin: theme.spacing(3, 0),
    [theme.breakpoints.down('xs')]: {
      fontSize: '22px',
      margin: theme.spacing(2, 0),
    },
  },
  tierCard: {
    borderRadius: '16px',
    backgroundColor: colors.purple3,
    backgroundImage: `url(${maskImage})`,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    [theme.breakpoints.down('md')]: {
      maxWidth: '650px',
    },
  },
  content: {
    margin: 'auto',
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(4),
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(2),
    },
  },
  header: {
    fontSize: '22px',
    color: 'white',
    [theme.breakpoints.down('xs')]: {
      fontSize: '16px',
    },
  },
  secondSectionHeader: {
    fontSize: '16px',
    color: 'white',
    [theme.breakpoints.down('xs')]: {
      fontSize: '14px',
      marginRight: '8px',
    },
  },
  secondSection: {
    fontSize: '14px',
    color: 'white',
  },
  chipItem: {
    backgroundColor: colors.purple7,
    color: 'white',
    height: 'fit-content',
    padding: theme.spacing(1),
    [theme.breakpoints.down('xs')]: {
      marginTop: theme.spacing(1),
    },
  },
  paymentButton: {
    backgroundColor: 'white',
    color: colors.purple3,
    fontSize: '16px',
    padding: theme.spacing(3, 1),
    marginTop: theme.spacing(1),
    [theme.breakpoints.down('md')]: {
      padding: '20px 8px',
      marginTop: theme.spacing(2),
    },
  },
  moneySection: {
    fontWeight: 600,
    color: 'white',
    fontSize: '22px',
    padding: theme.spacing(0, 1),
    [theme.breakpoints.down('xs')]: {
      fontSize: '20px',
    },
  },
  title: {
    color: colors.grey900,
    fontSize: '20px',
    fontWeight: 600,
    margin: theme.spacing(3, 0),
  },
  gridSecondsection: {
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'center',
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(1),
    },
  },
}));

export default function MyPayments(props: Props) {
  const classes = useStyles();
  return (
    <div className={classes.content}>
      <div className={classes.headerWrap}>
        <CustomButton style={{backgroundColor: 'white'}} to="/profile">
          <ArrowBack />
        </CustomButton>
        <Typography className={classes.headerText}>Mis pagos</Typography>
      </div>

      <div>
        <Typography className={classes.title}>Próximo Pago:</Typography>
        <Card className={classes.tierCard}>
          <CardContent>
            <Grid container justify="center" alignItems="center">
              <Hidden mdDown>
                <Grid item md={2}>
                  <Typography className={classes.header}>Enero 2021</Typography>
                </Grid>
                <Grid item md={5}>
                  <Typography className={classes.secondSection}>
                    Pago Mensual
                  </Typography>
                  <Typography className={classes.secondSectionHeader}>
                    Realizar el pago antes del 25 de enero
                  </Typography>
                </Grid>
                <Grid item md={3} style={{display: 'flex'}}>
                  <Chip className={classes.chipItem} label="Pendiente" />
                  <Typography className={classes.moneySection}>
                    S/. 35.50
                  </Typography>
                </Grid>
              </Hidden>

              <Hidden lgUp style={{marginBotoom: '20px'}}>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  style={{display: 'flex', justifyContent: 'space-between'}}
                >
                  <Typography className={classes.header}>Enero 2021</Typography>
                  <Typography className={classes.moneySection}>
                    S/. 35.50
                  </Typography>
                </Grid>
                <Grid
                  item
                  xs={6}
                  sm={6}
                  style={{display: 'flex', padding: '8px 0px '}}
                >
                  <Typography className={classes.secondSectionHeader}>
                    Realizar el pago antes del 25 de enero
                  </Typography>
                </Grid>
                <Grid item xs={6} sm={6} className={classes.gridSecondsection}>
                  <Typography className={classes.secondSection}>
                    Pago Mensual
                  </Typography>
                  <Chip className={classes.chipItem} label="Pendiente" />
                </Grid>
              </Hidden>

              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={2}
                style={{display: 'grid'}}
              >
                <Chip
                  className={classes.paymentButton}
                  label="Ir a pagar"
                  clickable
                  onDelete={() => null}
                  deleteIcon={
                    <ArrowForwardIcon style={{color: `${colors.purple3}`}} />
                  }
                />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </div>
      <div>
        <Typography className={classes.title}>Historial de Pagos</Typography>
        <CardReceipt />
      </div>
    </div>
  );
}

MyPayments.propTypes = {};
